import React, {useState, useEffect} from 'react';
import GoogleMapView from '@components/common/GoogleMap/GoogleMapPopup';
import CompanyBusinessService from '@services/company-business.service';
import ContactService from '@services/contact.service';
import {getLatLngFromAddress} from '@services/geocoding.service';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';
import ContactIntro from './ContactIntro';

export default function ContactUsTNH() {
    const [visible, setVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [open, setOpen] = useState(false);
    const [contactus, setContactUs] = useState(null);
    const [selectedMapUrl, setSelectedMapUrl] = useState(null);
    const {locale} = useRouter();

    const [formData, setFormData] = useState({
        full_name: '',
        phone_number: '',
        email: '',
        content: '',
        title: getLocaleContent(locale, 'page.contact-form.title_1'),
        gender: 1,
    });

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const loadCompanyBusiness = async () => {
        const companyBusiness = new CompanyBusinessService();
        try {
            const data = await companyBusiness.getCompanyBusiness({company_id: 31, locale: locale});
            if (data?.length) {
                setContactUs(data[0]);
                const fixedBusinesses = data[0].businesses.map(b => {
                    if (b.business_name.includes('Thái Nguyên') || b.business_name.includes('Thai Nguyen')) {
                        return {
                            ...b,
                            mapUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7419.92591351833!2d105.82976!3d21.587369!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc059ef64cbc6b293!2zQuG7h25oIFZp4buHbiBRdcO0zIFjIFTDqsyBIFRoYcyBaSBOZ3V5w6pu!5e0!3m2!1svi!2sus!4v1635393862311!5m2!1svi!2sus',
                        };
                    } else if (b.business_name.includes('Phổ Yên') || b.business_name.includes('Pho Yen')) {
                        return {
                            ...b,
                            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29716.751769817314!2d105.86719314840859!3d21.405886272490253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31351fe9a02a465d%3A0x861cba2d357f12c6!2zQuG7h25oIFZp4buHbiDEkGEgS2hvYSBZw6puIELDrG5oIFRow6FpIE5ndXnDqm4!5e0!3m2!1svi!2s!4v1686104129648!5m2!1svi!2s',
                        };
                    } else if (b.business_name.includes('Việt Yên') || b.business_name.includes('Viet Yen')) {
                        return {
                            ...b,
                            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.113232067809!2d106.10101907424647!3d21.26698497955583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x313513ef19bf8947%3A0x3a66fac7f166c8a!2zQuG7h25oIHZp4buHbiBUTkggVmnhu4d0IFnDqm4!5e0!3m2!1svi!2s!4v1734595877069!5m2!1svi!2s',
                        };
                    } else if (b.business_name.includes('Lạng Sơn') || b.business_name.includes('Lang Son')) {
                        return {
                            ...b,
                            mapUrl:
                                'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2919.859095899616!2d106.74893180722017!3d21.847053483705068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x36b54f0021135177%3A0x25c2c442cd3a15b0!2zQuG7h25oIHZp4buHbiBUTkggTOG6oW5nIFPGoW4!5e0!3m2!1svi!2s!4v1780049383996!5m2!1svi!2s',
                        };
                    }
                    return b;
                });
                setContactUs({...data[0], businesses: fixedBusinesses});
            }
        } catch (error) {
            console.error('Error fetching Contact us:', error);
        }
    };

    useEffect(() => {
        loadCompanyBusiness();
    }, []);

    const handleChange = e => {
        const {name, value} = e.target;
        setFormData(prev => ({...prev, [name]: value}));
        setErrors(prev => ({...prev, [name]: ''}));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.full_name.trim()) {
            newErrors.full_name = getLocaleContent(locale, 'page.booking-form.validation.full-name-required');
        } else if (formData.full_name.length < 2) {
            newErrors.full_name = getLocaleContent(locale, 'page.booking-form.validation.name-short');
        }

        if (!formData.email.trim()) {
            newErrors.email = getLocaleContent(locale, 'page.booking-form.validation.email-required');
        } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
            newErrors.email = getLocaleContent(locale, 'page.booking-form.validation.email-matches');
        }

        if (!formData.phone_number.trim()) {
            newErrors.phone_number = getLocaleContent(locale, 'page.booking-form.validation.phone-required');
        } else if (!/^0(?:3[2-9]|5[25689]|7[06-9]|8[1-689]|9[0-9])[0-9]{7}$/.test(formData.phone_number)) {
            newErrors.phone_number = getLocaleContent(locale, 'page.booking-form.validation.phone-matches');
        }

        if (!formData.content.trim()) {
            newErrors.content = getLocaleContent(locale, 'page.booking-form.validation.message-required');
        } else if (formData.content.length < 10) {
            newErrors.content = getLocaleContent(locale, 'page.booking-form.validation.message-matches');
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // 🧩 Submit form
    const handleSubmit = async e => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setMessage(null);

        try {
            const contactService = new ContactService();
            const res = await contactService.sendContact(formData);
            if (res) {
                setMessage(`✅ ${getLocaleContent(locale, 'page.booking-form.validation.submit_success')}`);
                setFormData({
                    full_name: '',
                    phone_number: '',
                    email: '',
                    content: '',
                    title: getLocaleContent(locale, 'page.contact-form.title_1'),
                    gender: 1,
                });
            } else {
                setMessage('❌ ' + getLocaleContent(locale, 'page.contact-form.failed'));
            }
        } catch (error) {
            setMessage('❌ ' + getLocaleContent(locale, 'page.booking-form.validation.submit_error'));
        } finally {
            setLoading(false);
        }
    };

    const handleViewMap = async business => {
        if (business.mapUrl) {
            setOpen(true);
            setSelectedMapUrl(business.mapUrl); // Thêm state này
        } else {
            // fallback: có lat/lng hoặc lấy từ geocode
            let {lat, lng, address} = business;
            if (!lat || !lng) {
                try {
                    const result = await getLatLngFromAddress(address);
                    if (result) {
                        lat = result.lat;
                        lng = result.lng;
                    }
                } catch (err) {
                    console.error('Không thể lấy tọa độ:', err);
                    return;
                }
            }
            setSelectedMapUrl(null);
            setOpen(true);
        }
    };

    const handleAddressClick = () => {
        let item = contactus.businesses?.[0];
        if (!item || !item.mapUrl) {
            console.warn('Địa chỉ không hợp lệ');
            return;
        }
        handleViewMap(item);
    };

    const handleAddressClickBusiness = business => {
        let item = business;
        if (!item || !item.mapUrl) {
            console.warn('Địa chỉ không hợp lệ');
            return;
        }
        handleViewMap(item);
    };

    if (!contactus) {
        return <div>Đang tải dữ liệu...</div>;
    }

    const {company_name, company_name_en, email, phone_number, address_full, address_en, businesses} = contactus;

    return (
        <div>
            <section className="contact-us">
                {/* Company Info */}
                <div className="company">
                    <div className="company-info">
                        <div className="company-info-title">
                            <h2>{locale === 'vn' ? company_name : company_name_en}</h2>
                            <p>
                                {locale === 'vn'
                                    ? businesses?.[0]?.business_license
                                    : businesses?.[0]?.business_license_en ||
                                      getLocaleContent(locale, 'page.contact-us.update')}
                            </p>
                            <div className="company-license">
                                <img src="/bw_image/gpdk-popup.png" alt="giấy phép" />
                                <div className="cert">
                                    <div>
                                        <strong>{getLocaleContent(locale, 'page.contact-us.license')}</strong>{' '}
                                        {locale === 'vn'
                                            ? businesses?.[0]?.business_license
                                            : businesses?.[0]?.business_license_en ||
                                              getLocaleContent(locale, 'page.contact-us.update')}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="separate"></div>
                        <ul>
                            <li>
                                <img src="/bw_image/phone-popup.png" alt="phone" />
                                <strong>Hotline:</strong> <a href={`tel:${phone_number}`}>{phone_number}</a>
                            </li>

                            <li>
                                <img src="/bw_image/email-popup.png" alt="email" />
                                <strong>Email:</strong> <a href={`mailto:${email}`}>{email}</a>
                            </li>

                            <li onClick={() => handleAddressClick()}>
                                <img src="/bw_image/location-popup.png" alt="location" />
                                <strong>{getLocaleContent(locale, 'page.contact-us.address')}</strong>{' '}
                                <span>{locale === 'vn' ? address_full : address_en}</span>
                            </li>
                        </ul>
                    </div>

                    {/* Hospitals */}
                    <div className="hospital-list">
                        {businesses.map((b, index) => (
                            <div className="hospital-card-contact-us" key={b.business_id}>
                                <div className="hospital-contact-us-img">
                                    <img src={b.business_image} alt={b.business_name} />
                                </div>
                                <div className="hospital-contact-us-info">
                                    <h3>{locale === 'vn' ? b.business_name : b.business_name_en}</h3>
                                    <p>{locale === 'vn' ? b.business_license : b.business_license_en}</p>
                                    <div className="hospital-contact-us-info-cert">
                                        <p>
                                            <strong>{getLocaleContent(locale, 'page.contact-us.license')}</strong>{' '}
                                            {locale === 'vn' ? b.business_license : b.business_license_en}
                                        </p>
                                    </div>
                                    <ul>
                                        <li
                                            style={{cursor: 'pointer'}}
                                            onClick={() => {
                                                window.location.href = `tel:${b.phone_number}`;
                                            }}>
                                            <img src="/bw_image/call-f.svg" alt="phone" />
                                            <span>{b.phone_number}</span>
                                        </li>
                                        <li
                                            onClick={() => {
                                                if (b.email) window.location.href = `mailto:${b.email}`;
                                            }}>
                                            <img src="/bw_image/mail-f.svg" alt="email" style={{marginRight: 8}} />
                                            {b.email || 'Chưa có email'}
                                        </li>
                                        <li onClick={() => handleAddressClickBusiness(b)}>
                                            <img src="/bw_image/location-f.svg" alt="address" />{' '}
                                            {locale === 'vn' ? b.address : b.address_en}
                                        </li>
                                    </ul>
                                    <button
                                        type="button"
                                        onClick={() => handleViewMap(b)}
                                        className="hospital-map">
                                        {getLocaleContent(locale, 'page.contact-us.view_map')}
                                    </button>
                                    <span className="hospital-number">{String(index + 1).padStart(2, '0')}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="space"></div>
            </section>

            {/* Tab dọc (mobile) */}
            <button type="button" className="contact-tab" onClick={() => setVisible(!visible)}>
                {getLocaleContent(locale, 'page.contact-us.title')}
            </button>

            {/* Popup form */}
            <div className={`contact-us-form ${visible ? 'show' : 'hide'}`}>
                <button
                    type="button"
                    className={`close-btn-contact-us`}
                    aria-label={locale === 'en' ? 'Close contact form' : 'Đóng biểu mẫu liên hệ'}
                    onClick={() => setVisible(false)}>
                    <img src="/bw_image/close-popup.png" alt="close" />
                </button>
                <h3>{getLocaleContent(locale, 'page.contact-form.title')}</h3>
                <span>{getLocaleContent(locale, 'page.contact-form.description')}</span>

                <form onSubmit={handleSubmit}>
                    <div className="info">
                        <input
                            name="full_name"
                            type="text"
                            placeholder={getLocaleContent(locale, 'page.booking-form.full-name') + ' (*)'}
                            value={formData.full_name}
                            onChange={handleChange}
                            className={errors.full_name ? 'error' : ''}
                        />
                        {errors.full_name && <small className="error-text">{errors.full_name}</small>}
                    </div>
                    <div className="info">
                        <input
                            name="phone_number"
                            type="text"
                            maxLength={10}
                            pattern="[0-9]*"
                            placeholder={getLocaleContent(locale, 'page.booking-form.phone') + ' (*)'}
                            value={formData.phone_number}
                            onChange={handleChange}
                            className={errors.phone_number ? 'error' : ''}
                        />
                        {errors.phone_number && <small className="error-text">{errors.phone_number}</small>}
                    </div>
                    <div className="info">
                        <input
                            name="email"
                            type="email"
                            placeholder="Email (*)"
                            value={formData.email}
                            onChange={handleChange}
                            className={errors.email ? 'error' : ''}
                        />
                        {errors.email && <small className="error-text">{errors.email}</small>}
                    </div>
                    <div className="info">
                        <textarea
                            name="content"
                            className={`info-contact-us-textarea ${errors.content ? 'error' : ''}`}
                            placeholder={getLocaleContent(locale, 'page.booking-form.message') + ' (*)'}
                            value={formData.content}
                            onChange={handleChange}></textarea>
                        {errors.content && <small className="error-text">{errors.content}</small>}
                    </div>

                    {message && <p className="contact-message">{message}</p>}

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? 'Đang gửi...' : 'Gửi'}
                        {!loading && <img src="/bw_image/arrow-long-right-whilte.png" alt="arrow" />}
                    </button>
                </form>
            </div>

            {!visible && !isMobile && (
                <div className="contact-intro-wrapper">
                    <ContactIntro onClick={() => setVisible(true)} />
                </div>
            )}

            {/* Google Map */}
            <GoogleMapView mapUrl={selectedMapUrl} open={open} onClose={() => setOpen(false)} />
        </div>
    );
}
